import React from 'react';

import StickyElement from '@app/components/bulk-actions/bar/components/sticky-element/sticky-element';

import style from './bar.module.scss';

type Props = {
  children: React.ReactNode;
};

export const BulkActionsBar = ({ children }: Props) => {
  return (
    <StickyElement
      shouldStick
      className={style.BulkActionsMenu}
    >
      <div className={style.Content}>{children}</div>
    </StickyElement>
  );
};
